import { useMemo } from "react";
import { getVideoEmbed } from "../../../utils/videoEmbeds";
import "./VideoEmbedPlayer.css";

type VideoEmbedPlayerProps = {
  videoUrl: string;
  title?: string;
  autoplay?: boolean;
  disableDownload?: boolean;
};

export default function VideoEmbedPlayer({
  videoUrl,
  title = "Video",
  autoplay = false,
  disableDownload = false,
}: VideoEmbedPlayerProps) {
  const embed = useMemo(
    () => getVideoEmbed(videoUrl, autoplay),
    [autoplay, videoUrl],
  );

  if (!embed) {
    return null;
  }

  if (embed.type === "file") {
    return (
      <div
        className="video-embed-player"
        onContextMenu={disableDownload ? (event) => event.preventDefault() : undefined}
      >
        <div className="video-embed-player-frame">
          <video
            className="video-embed-player-video"
            src={embed.url}
            controls
            controlsList={
              disableDownload
                ? "nodownload noplaybackrate noremoteplayback"
                : undefined
            }
            disablePictureInPicture={disableDownload}
            disableRemotePlayback={disableDownload}
            autoPlay={autoplay}
            playsInline
            draggable={false}
            title={title}
            onContextMenu={disableDownload ? (event) => event.preventDefault() : undefined}
            onDragStart={disableDownload ? (event) => event.preventDefault() : undefined}
          >
            <track kind="captions" />
          </video>
        </div>
      </div>
    );
  }

  return (
    <div className="video-embed-player">
      <div className="video-embed-player-frame">
        <iframe
          src={embed.url}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="video-embed-player-iframe"
          title={title}
        />
      </div>
    </div>
  );
}
